import * as S from './About.styles.js';
import { type UserProfile_userProfile$key } from '@/__generated__/relay/UserProfile_userProfile.graphql.js';
import { Layout } from '@/components/Layout/Layout.js';
import { MobileAbout } from '@/components/MobileAbout/MobileAbout.js';
import { Section } from '@/components/Section/Section.js';
import { SocialLinks } from '@/components/SocialLinks/SocialLinks.js';
import { UserProfileFragment } from '@/documents/fragments/UserProfile.js';
import { useIPFragment } from '@/hooks/useIPFragment.js';
import { useMatchMedia } from '@/hooks/useMatchMedia.js';
import { useUserProfile } from '@/hooks/useUserProfile.js';
import { minWidthMediaQueries } from '@/stitches/media.js';
import { LocationIcon } from '@contra/icons/icons';

export const About = ({
  queryRef,
}: {
  readonly queryRef: UserProfile_userProfile$key;
}) => {
  const isMediumViewport = useMatchMedia(minWidthMediaQueries.bp2);
  const userProfile = useUserProfile();
  const result = useIPFragment<UserProfile_userProfile$key>(
    UserProfileFragment,
    queryRef,
  );

  if (!userProfile) return null;
  const location = userProfile.location ?? '';
  const trimmedLocation = location.split(',').slice(0, 2).join(',');
  const firstName = userProfile.firstName ?? '';
  const bio = userProfile.bio ?? null;
  const hasBio = Boolean(bio);

  if (!result || !hasBio) return null;

  return isMediumViewport ? (
    <Section
      css={{ alignItems: 'center', gap: '$24', marginTop: '$88' }}
      id="about"
    >
      <Layout.FlexColumn css={{ alignItems: 'center' }}>
        <S.AboutHeading>Meet {firstName}</S.AboutHeading>
        <S.BioText>{bio}</S.BioText>
      </Layout.FlexColumn>
      <Layout.FlexRow css={{ gap: '$24' }}>
        <S.LocationContainer>
          <LocationIcon />
          <span>{trimmedLocation}</span>
        </S.LocationContainer>
        <S.Divider />
        <SocialLinks />
      </Layout.FlexRow>
    </Section>
  ) : (
    <MobileAbout
      profile={result}
      uppercaseTrigger={false}
    />
  );
};
